/**
 * DecisionFlow — CertificationPanel
 * ui/src/shells/CertificationPanel.jsx
 *
 * S648 — Certify & Close screen.
 *
 * Replaces the original simple card with FiscalPeriodManager as the primary
 * surface. FiscalPeriodManager owns all data fetching, dual-approval certify
 * action flow, lock, and roll-forward. This component is a thin shell that
 * positions it correctly within the CompAdminShell route.
 *
 * The original CertificationPanel card content (period status display, close
 * button) is superseded — all lifecycle actions now live in FiscalPeriodManager
 * where they are driven by the full period list and per-row action surface.
 *
 * Props:
 *   mode    — "dev" | "prod"  (passed through — not currently used but kept
 *             for interface stability with CompAdminShell route binding)
 *   period  — active fiscal period object | null (not used — FiscalPeriodManager
 *             fetches its own period list; prop kept for interface stability)
 *
 * Used in:
 *   CompAdminShell — /admin/certification (EXECUTE nav group, "Certify & Close")
 *
 * Auth: FiscalPeriodManager uses useAuth() directly — ARCH-2 compliant.
 */

import FiscalPeriodManager from "../components/tenant-admin/FiscalPeriodManager.jsx";

// ---------------------------------------------------------------------------
// CertificationPanel — exported default
// ---------------------------------------------------------------------------

export default function CertificationPanel({ mode, period }) {
  return (
    <FiscalPeriodManager />
  );
}
